module.exports = __webpack_public_path__ + "static/media/photo40.4b03fb9c.jpg";